export default __webpack_public_path__ + "61356bc0f617a8a003377834b5254904.svg";